// icon:flower | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

export default function Place(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11 14"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
        <path
              d="M5.25000254 0C2.34891129 0 0 2.35194645 0 5.25000254 0 7.19460895.65600422 7.80229675 4.13631841 13.382694c.51365259.8235668 1.71428989.8225824 2.22734092 0C9.84580555 7.79937097 10.5 7.19422614 10.5 5.25000254 10.5 2.34891129 8.14805863 0 5.25000254 0Zm0 12.6875061c-3.48425168-5.5867136-3.9375019-5.93939346-3.9375019-7.43750356 0-2.17462214 1.76287976-3.9375019 3.9375019-3.9375019 2.17462215 0 3.93750191 1.76287976 3.93750191 3.9375019 0 1.49168432-.41469551 1.78896571-3.93750191 7.43750356ZM3.06250148 5.25000254c0-1.20812949.97937157-2.18750106 2.18750106-2.18750106 1.20812949 0 2.18750106.97937157 2.18750106 2.18750106 0 1.20812949-.97937157 2.18750106-2.18750106 2.18750106-1.20812949 0-2.18750106-.97937157-2.18750106-2.18750106Z"/>
    </svg>
  );
}
